import { defineStore } from 'pinia'

import helpers from '~/helpers'
import JsonApiHelper from '~/helpers/json-api-helper'
import type { SpecialistIssuesData } from '~/types/specialist-issues'

export const messages = {
  failedToGetIssues: 'Не удалось получить проблематики.',
}

type State = {
  isDataLoading: boolean
  issuesData: SpecialistIssuesData[]
}

const initialState = (): State => ({
  isDataLoading: false,
  issuesData: [
    {
      id: '1',
      type: 'specialistIssues',
      attributes: { name: 'Повышенная температура (жар)' }
    },
    {
      id: '2',
      type: 'specialistIssues',
      attributes: { name: 'Боль в животе (желудке)' }
    },
    {
      id: '3',
      type: 'specialistIssues',
      attributes: { name: 'Головная боль или мигрень' }
    },
    {
      id: '4',
      type: 'specialistIssues',
      attributes: { name: 'Постоянная усталость и слабость' }
    },
    {
      id: '5',
      type: 'specialistIssues',
      attributes: { name: 'Боли в суставах' }
    },
    {
      id: '6',
      type: 'specialistIssues',
      attributes: { name: 'Кашель и заложенность носа' }
    },
    {
      id: '7',
      type: 'specialistIssues',
      attributes: { name: 'Одышка или затрудненное дыхание' }
    },
    {
      id: '8',
      type: 'specialistIssues',
      attributes: { name: 'Боль в спине или шее' }
    },
    {
      id: '9',
      type: 'specialistIssues',
      attributes: { name: 'Проблемы с кожей (прыщи, воспаления)' }
    },
    {
      id: '10',
      type: 'specialistIssues',
      attributes: { name: 'Проблемы с пищеварением (изжога, запоры, диарея)' }
    },
    {
      id: '11',
      type: 'specialistIssues',
      attributes: { name: 'Боль в груди' }
    },
    {
      id: '12',
      type: 'specialistIssues',
      attributes: { name: 'Проблемы с иммунитетом' }
    },
    {
      id: '13',
      type: 'specialistIssues',
      attributes: { name: 'Отеки и отечность' }
    },
    {
      id: '14',
      type: 'specialistIssues',
      attributes: { name: 'Проблемы с памятью или концентрацией' }
    },
    {
      id: '15',
      type: 'specialistIssues',
      attributes: { name: 'Частые головокружения' }
    },
    {
      id: '16',
      type: 'specialistIssues',
      attributes: { name: 'Учащенное или нерегулярное сердцебиение' }
    },
    {
      id: '17',
      type: 'specialistIssues',
      attributes: { name: 'Проблемы со сном (бессонница)' }
    },
    {
      id: '18',
      type: 'specialistIssues',
      attributes: { name: 'Сухость кожи или волос' }
    },
    {
      id: '19',
      type: 'specialistIssues',
      attributes: { name: 'Ломкость ногтей' }
    },
    {
      id: '20',
      type: 'specialistIssues',
      attributes: { name: 'Ухудшение зрения или боль в глазах' }
    },
  ]
})

export const useSpecialistIssuesStore = defineStore('specialist-issues', {
  state: () => initialState(),
  getters: {
    getIssues: (state: State) => state.issuesData,
  },
  actions: {
    async fetchIssues (): Promise<void> {
      const { $apiHelper, $toast } = useNuxtApp()

      this.isDataLoading = true

      const params = helpers.getParams([])

      try {
        const response = await $apiHelper.specialistIssues.getSpecialistIssues(params) as any
        const { data } = JsonApiHelper.denormalizeResponse(response) as any

        this.issuesData = data
      } catch (error) {
        console.error(error)
        $toast.error(messages.failedToGetIssues)
      }

      this.isDataLoading = false
    },
  }
})
